import { MenuItem, CustomerReview, TripAdvisorProfileData } from '../types';
import { APPLE_MANGO_SLUSHY_DATA_URI } from '../assets/appleMangoSlushyBase64';

// Clean image placeholders - populated with all real images from public/
export const CLIENT_IMAGES = {
  // Brand Logo
  logo: '/logo.webp',

  // 2024 Award Image
  award2024: '/2024 Award.jpeg',
  
  // Kiosk, Terrace & Bar Team
  kiosk: '/genuine-bar-selfie.webp',
  barSelfie: '/genuine-bar-selfie.webp',
  barTeam: '/genuine-bar-selfie.webp',
  kioskExterior: '/childern_2.webp',
  
  // Homepage Hero Elements
  heroBg: '',
  heroVideo: '/hero-video.mp4',
  cateringVideo: '/catering-video.mp4',
  heroBurger: '/dishes/Caribbean Chilli Cheese Burger.webp',
  heroDonut: '/donut-img.jpeg',
  heroAlcohol: '/drinks/cruzcampo-pint.webp',
  heroDrink: '/frankies_cheesy_fries_slushy.webp',
  sunsetBeach: '',
  
  // Food Items
  food1Burger: '/dishes/Beef Burger.webp',
  food2LoadedChips: '/dishes/pepperoni-cheese-loaded-fries.webp',
  food3Feast: '/dishes/fish-fingers-cheese-loaded-fries.webp',
  food4ChipsDuo: '/dishes/cheesy-fries.webp',
  food5BaconBurger: '/dishes/Bacon Cheese Burger.webp',
  food6ChickenChips: '/dishes/southern-fried-chicken-cheese-loaded-fries.webp',
  food7BurgerDogCombo: '/dishes/Double Egg Cheese Burger.webp',
  food8BurgerSlushy: '/dishes/Caribbean Chilli Cheese Burger.webp',
  beefBurger: '/dishes/Beef Burger.webp',
  baconCheeseBurger: '/dishes/Bacon Cheese Burger.webp',
  caribbeanChilliBurger: '/dishes/Caribbean Chilli Cheese Burger.webp',
  doubleEggBurger: '/dishes/Double Egg Cheese Burger.webp',
  stiltonCheeseBurger: '/dishes/Stilton Cheese Bacon Burger.webp',
  vegetableBurger: '/dishes/Supreme Veggie Burger.webp',
  chickenCheeseBurger: '/dishes/Chicken Cheese Burger.webp',
  chickenJackBurger: '/dishes/Chicken Jack Burger.webp',
  venisonBurger: '/dishes/Venison Burger.webp',
  pepperoniFries: '/dishes/pepperoni-cheese-loaded-fries.webp',
  cheesyFries: '/dishes/cheesy-fries.webp',
  chickenLoadedFries: '/dishes/southern-fried-chicken-cheese-loaded-fries.webp',
  fishFingersLoadedFries: '/dishes/fish-fingers-cheese-loaded-fries.webp',
  baconRoll3Rashers: '/dishes/Bacon Roll 3 Rashers.webp',
  baconRollMeltedCheese: '/dishes/Bacon Roll topped with Melted.webp',
  baconRoll2Eggs: '/dishes/3 Rashers of Bacon with 2 Eggs in Roll.webp',
  baconTomatoRoll: '/dishes/Bacon and Tomato Roll.webp',
  baconLettuceTomatoRoll: '/dishes/Bacon, Lettuce and Tomato Roll.webp',
  drinksMenu: '/frankies_cheesy_fries_slushy.webp',
  strawberrySlushy: '/dishes/Strawberry Slushy 568ml.webp',
  raspberrySlushy: '/dishes/Raspberry Slushy 568ml.webp',
  sourCherrySlushy: '/dishes/Sour Cherry slushy 568ml.webp',
  cocaColaSlushy: '/dishes/Coca-Cola Slushy 568ml.webp',
  lemonLimeSlushy: '/dishes/Lemon and Lime Slushy 568ml.webp',
  appleMangoSlushy: APPLE_MANGO_SLUSHY_DATA_URI,
  coffeeLatte: '/frankies_cheesy_fries_slushy.webp',
  coffeeAmericano: '/frankies_cheesy_fries_slushy.webp',
  luxuryHotChoc: '/frankies_cheesy_fries_slushy.webp',
  icedLatte: '/frankies_cheesy_fries_slushy.webp',
  caramelFrappe: '/frankies_cheesy_fries_slushy.webp',
  
  // Specialties
  baconSandwichHighRes: '/Bacon-sandwich.webp',
  baconSandwichTable: '/Bacon-sandwich.webp',
  chilliCheeseDog: '/chilli_cheese_dog.webp',
  cheesyFriesSlushy: '/frankies_cheesy_fries_slushy.webp',
  sausageTray: '/frankies_sausage_tray.webp',
  hotWings: '/Hot-Wings.webp',
  footlongFrankfurter: '/dishes/The Footlong Frankfurter.webp',
  lincolnshireLongDog: '/dishes/The Lincolnshire Long Dog.webp',
  perfectChips: '/classic_salted_fries.webp',
  perfectlyCookedChips: '/perfectly_cooked_chips.webp',
  
  // Ramsgate Beach Playing & Rides
  childrenSlide: '/childern_1.webp',
  childrenKiddiesCorner: '/childern_2.webp',
  childrenTrampolines: '/childern_3.webp',
  childrenCarousel: '/childern_4.webp',
  childrenPlayArea: '/childern_1.webp',
  childrenScooter: '/childern_4.webp',

  // Ramsgate Main Sands Photography
  ramsgateSand: '/ramsgate-sand.webp',
  ramsgateSandFallback: '/ramsgate sand.jpeg',
  ramsgateSand2: '/ramsgate-sand-2.webp',
  ramsgateSand2Fallback: '/ramsgate sand 2.jpeg',
  ramsgateSand3: '/ramsgate-sand-3.webp',
  ramsgateSand3Fallback: '/ramsgate sand 3.jpeg',
  ramsgateSand4: '/ramsgate-sand-4.webp',
  ramsgateSand4Fallback: '/ramsgate sand 4.jpeg',

  // Beach Hire Equipment
  sunLounges: '/sun-lounges.webp',
  sunLoungesFallback: '/Sun Lounges.jpeg',
  beachHireBanner: '/frankies-beach-hire-banner.jpg',

  // Promenade Seating Video & Media
  promenadeSeatingVideo: '/promenade-seating.mp4',
  promenadeSeatingVideoFallback: '/PROMENADE SEATING.mp4',
  promenadeSeatingPoster: '/promenade-seating-poster.webp',
  promenadeSeatingPosterFallback: '/promenade-seating-poster.jpg',
};

export interface RamsgateSandImage {
  id: string;
  title: string;
  label: string;
  src: string;
  fallback?: string;
  alt: string;
  caption: string;
}

export const RAMSGATE_SAND_IMAGES: RamsgateSandImage[] = [
  {
    id: 'ramsgate-sand-1',
    title: 'Ramsgate Main Sands',
    label: 'Photo 1',
    src: '/ramsgate-sand.webp',
    fallback: '/ramsgate sand.jpeg',
    alt: 'Ramsgate Sand - Beachfront panorama of Ramsgate Main Sands',
    caption: 'Soft golden sands and refreshing coastal waves directly outside Frankie’s Kiosk 1',
  },
  {
    id: 'ramsgate-sand-2',
    title: 'Ramsgate Sand Beach',
    label: 'Photo 2',
    src: '/ramsgate-sand-2.webp',
    fallback: '/ramsgate sand 2.jpeg',
    alt: 'Ramsgate Sand 2 - Golden sandy beach and sunny seafront at Ramsgate',
    caption: 'Sun-drenched golden sands and seaside visitors enjoying the Ramsgate coastline',
  },
  {
    id: 'ramsgate-sand-3',
    title: 'Ramsgate Sand Esplanade',
    label: 'Photo 3',
    src: '/ramsgate-sand-3.webp',
    fallback: '/ramsgate sand 3.jpeg',
    alt: 'Ramsgate Sand 3 - Scenic Ramsgate Main Sands beach and coastal esplanade',
    caption: 'Breathtaking coastal vista along Marina Esplanade and Ramsgate beach promenade',
  },
  {
    id: 'ramsgate-sand-4',
    title: 'Ramsgate Sand Shoreline',
    label: 'Photo 4',
    src: '/ramsgate-sand-4.webp',
    fallback: '/ramsgate sand 4.jpeg',
    alt: 'Ramsgate Sand 4 - Expansive golden beach and seaside view',
    caption: 'Clean, expansive sands looking out towards the sea and historic Ramsgate harbour',
  },
];

export const ASSETS = {
  // Brand Logo
  logo: '/logo.webp',

  // 2024 Award
  award2024: '/2024 Award.jpeg',
  
  // Kiosk & Atmosphere
  kiosk: '/genuine-bar-selfie.webp',
  barSelfie: '/genuine-bar-selfie.webp',
  beachPatio: '/childern_2.webp',
  sunLounges: '/sun-lounges.webp',
  sunLoungesFallback: '/Sun Lounges.jpeg',
  beachHireBanner: '/frankies-beach-hire-banner.jpg',
  tropicalDrink: '/frankies_cheesy_fries_slushy.webp',
  sunsetBeach: '',
  heroBeachBg: '',
  heroVideo: '/hero-video.mp4',
  cateringVideo: '/catering-video.mp4',
  video1: '/video-1-frankie.mp4',
  video2: '/video-2-frankie.mp4',
  video3: '/video-3-frankie.mp4',
  video4: '/video-4-frankie.mp4',
  video5: '/video-5-frankie.mp4',
  video6: '/video-6-frankie.mp4',

  // Food Images
  heroBurger: '/dishes/Caribbean Chilli Cheese Burger.webp',
  heroDonut: '/donut-img.jpeg',
  heroAlcohol: '/drinks/cruzcampo-pint.webp',
  beefBurger: '/dishes/Beef Burger.webp',
  baconBurger: '/dishes/Bacon Cheese Burger.webp',
  spicyBurger: '/dishes/Caribbean Chilli Cheese Burger.webp',
  doubleEggBurger: '/dishes/Double Egg Cheese Burger.webp',
  stiltonBurger: '/dishes/Stilton Cheese Bacon Burger.webp',
  veggieBurger: '/dishes/Supreme Veggie Burger.webp',
  chickenCheeseBurger: '/dishes/Chicken Cheese Burger.webp',
  chickenJackBurger: '/dishes/Chicken Jack Burger.webp',
  venisonBurger: '/dishes/Venison Burger.webp',
  loadedFries: '/dishes/pepperoni-cheese-loaded-fries.webp',
  cheesyFries: '/dishes/cheesy-fries.webp',
  boardwalkDog: '/dishes/The Lincolnshire Long Dog.webp',
  footlongFrankfurter: '/dishes/The Footlong Frankfurter.webp',
  lincolnshireLongDog: '/dishes/The Lincolnshire Long Dog.webp',
  chilliCheeseDog: '/dishes/The Footlong Frankfurter.webp',
  slicedSausage: '/frankies_sausage_tray.webp',
  friesSlushyCombo: '/frankies_cheesy_fries_slushy.webp',
  chickenLoadedFries: '/dishes/southern-fried-chicken-cheese-loaded-fries.webp',
  fishFingersLoadedFries: '/dishes/fish-fingers-cheese-loaded-fries.webp',
  baconRoll3Rashers: '/dishes/Bacon Roll 3 Rashers.webp',
  baconRollMeltedCheese: '/dishes/Bacon Roll topped with Melted.webp',
  baconRoll2Eggs: '/dishes/3 Rashers of Bacon with 2 Eggs in Roll.webp',
  baconTomatoRoll: '/dishes/Bacon and Tomato Roll.webp',
  baconLettuceTomatoRoll: '/dishes/Bacon, Lettuce and Tomato Roll.webp',
  classicSaltedFries: '/classic_salted_fries.webp',
  baconSandwich: '/Bacon-sandwich.webp',
  baconSandwichTable: '/Bacon-sandwich.webp',
  hotWings: '/Hot-Wings.webp',
  chipsFeast: '/dishes/fish-fingers-cheese-loaded-fries.webp',
  chipsDuo: '/dishes/cheesy-fries.webp',
  cookedChips: '/perfectly_cooked_chips.webp',
  drinksMenu: '/frankies_cheesy_fries_slushy.webp',
  strawberrySlushy: '/dishes/Strawberry Slushy 568ml.webp',
  raspberrySlushy: '/dishes/Raspberry Slushy 568ml.webp',
  sourCherrySlushy: '/dishes/Sour Cherry slushy 568ml.webp',
  cocaColaSlushy: '/dishes/Coca-Cola Slushy 568ml.webp',
  lemonLimeSlushy: '/dishes/Lemon and Lime Slushy 568ml.webp',
  appleMangoSlushy: APPLE_MANGO_SLUSHY_DATA_URI,

  // Kids & Family Funfair
  children1: '/childern_1.webp',
  children2: '/childern_2.webp',
  children3: '/childern_3.webp',
  children4: '/childern_4.webp',
  childrenScooter: '/childern_4.webp',

  // Local fallback images
  fallbacks: {
    heroBurger: '/dishes/Beef Burger.webp',
    beefBurger: '/dishes/Beef Burger.webp',
    baconBurger: '/dishes/Bacon Cheese Burger.webp',
    spicyBurger: '/dishes/Caribbean Chilli Cheese Burger.webp',
    loadedFries: '/dishes/pepperoni-cheese-loaded-fries.webp',
    cheesyFries: '/dishes/cheesy-fries.webp',
    chickenLoadedFries: '/dishes/southern-fried-chicken-cheese-loaded-fries.webp',
    fishFingersLoadedFries: '/dishes/fish-fingers-cheese-loaded-fries.webp',
    baconRoll3Rashers: '/dishes/Bacon Roll 3 Rashers.webp',
    baconRollMeltedCheese: '/dishes/Bacon Roll topped with Melted.webp',
    baconRoll2Eggs: '/dishes/3 Rashers of Bacon with 2 Eggs in Roll.webp',
    baconTomatoRoll: '/dishes/Bacon and Tomato Roll.webp',
    baconLettuceTomatoRoll: '/dishes/Bacon, Lettuce and Tomato Roll.webp',
    boardwalkDog: '/dishes/The Lincolnshire Long Dog.webp',
    lincolnshireLongDog: '/dishes/The Lincolnshire Long Dog.webp',
    footlongFrankfurter: '/dishes/The Footlong Frankfurter.webp',
    chilliCheeseDog: '/dishes/The Footlong Frankfurter.webp',
    slicedSausage: '/frankies_sausage_tray.webp',
    friesSlushyCombo: '/frankies_cheesy_fries_slushy.webp',
    classicSaltedFries: '/classic_salted_fries.webp',
    beachPatio: '/childern_2.webp',
    childrenScooter: '/childern_4.webp',
  },
};

// Official Social & Profile Links
export const FRANKIES_FACEBOOK_URL = 'https://www.facebook.com/profile.php?id=61572325055640';

// National Press & Tripadvisor Best of the Best Award
export const NATIONAL_AWARD_DATA = {
  awardTitle: "Tripadvisor Travellers' Choice: Best of the Best",
  nationalRank: "Ranked Among the Top in the Entire UK",
  sunArticleUrl: "https://www.thesun.co.uk/travel/30659182/tiny-seaside-food-hut-uk-best-restaurant/",
  quote: "The tiny seaside food hut crowned among the UK's best!",
  source: "The Sun",
  description:
    "Honoured in Tripadvisor's prestigious Travellers' Choice 'Best of the Best' awards — putting our humble Ramsgate beachfront food kiosk on the national culinary map as one of the best seaside spots in Great Britain.",
};

// Local Customer Service Award: 1066 Business Awards Extra Mile
export const EXTRA_MILE_AWARD_DATA = {
  awardTitle: "2024 Extra Mile Award Winner",
  category: "Extra Mile for Customer Service & Satisfaction",
  ceremony: "1066 Business Awards",
  sponsor: "Sponsored by Goldstar IT Consultancy",
  summary:
    "Celebrating an organisation that goes above and beyond, setting the gold standard for customer service and satisfaction.",
  quote:
    "For a small business like Frankies, we could see the commitment to achieving the extra mile in customer service was engrained in the culture of Frankies which is why we felt they deserved the award.",
  quoteAuthor: "Paul Goldsmith, Director, Goldstar IT Consultancy",
  badge: "Gold Standard Customer Service",
};

// Independent Food Critic Review: Anne at the table
export const FOOD_CRITIC_REVIEW = {
  criticName: "Anne at the table",
  channelUrl: "https://www.youtube.com/@Anneatthetable",
  videoUrl: "https://www.youtube.com/watch?v=vmb1puvkpv4",
  shareUrl: "https://share.google/OwKrYWjfgs6UGNCO8",
  embedUrl: "https://www.youtube.com/embed/vmb1puvkpv4",
  thumbnailUrl: "https://i.ytimg.com/vi/vmb1puvkpv4/hqdefault.jpg",
  title: "Trying the BEST Beach Food in the UK? Frankie's Food Review",
  rating: "8.5 / 10",
  verdict: "TripAdvisor was spot on — well worth a visit when visiting the Kent Coast!",
  summary:
    "Independent food critic Anne visited Frankie's beachfront kiosk to sample the menu and test whether TripAdvisor's #1 Quick Bites ranking held up. She sampled the German Bratwurst, Caribbean Chicken Burger, and fresh chips right by the sea.",
  sampledItems: [
    {
      name: "German Bratwurst & Onions",
      review: "Good sausage, nice bite to it, good flavour, cooked nicely with generous toppings.",
      rating: "Very High",
    },
    {
      name: "Caribbean Chicken Burger",
      review: "Loads of flavour and specialty seasonings you don't typically find at beach food vans.",
      rating: "Standout Dish",
    },
    {
      name: "Golden Seaside Chips",
      review: "Proper hot crispy chips enjoyed right with panoramic sea views.",
      rating: "Classic",
    },
  ],
};

// Frankie's Beach Videos (Video 1 through Video 6)
export interface FrankieVideoItem {
  id: string;
  number: number;
  title: string;
  subtitle: string;
  src: string;
  fallbackSrc: string;
  poster: string;
  posterJpg: string;
  tag: string;
  description: string;
}

export const FRANKIE_VIDEOS: FrankieVideoItem[] = [
  {
    id: 'video-1',
    number: 1,
    title: 'Frankie at the Beach — Video 1',
    subtitle: 'Ramsgate Beach Atmosphere & Fresh Grill',
    src: '/video-1-frankie.mp4',
    fallbackSrc: '/video 1 frankie.mp4',
    poster: '/video-1-poster.jpg',
    posterJpg: '/video-1-poster.jpg',
    tag: 'Beachfront Vibe',
    description: 'Experience the real atmosphere right on Ramsgate Sands with fresh food cooking on the grill and sea breezes.',
  },
  {
    id: 'video-2',
    number: 2,
    title: 'Frankie at the Beach — Video 2',
    subtitle: 'Seaside Energy & Boardwalk Moments',
    src: '/video-2-frankie.mp4',
    fallbackSrc: '/video 2 frankie.mp4',
    poster: '/video-2-poster.jpg',
    posterJpg: '/video-2-poster.jpg',
    tag: 'Coast in Action',
    description: 'A genuine glimpse of Frankie’s kiosk in action on the sands — laughter, seaside energy, and coastal memories.',
  },
  {
    id: 'video-3',
    number: 3,
    title: 'Frankie at the Beach — Video 3',
    subtitle: 'Award-Winning Hospitality & Refreshments',
    src: '/video-3-frankie.mp4',
    fallbackSrc: '/video 3 frankie.mp4',
    poster: '/video-3-poster.jpg',
    posterJpg: '/video-3-poster.jpg',
    tag: 'Award Winner',
    description: 'TripAdvisor Travelers’ Choice award-winning food, refreshing iced slushies, beach cocktails, and ice-cold beers served right on the beach.',
  },
  {
    id: 'video-4',
    number: 4,
    title: 'Frankie at the Beach — Video 4',
    subtitle: 'Beach Swings & TripAdvisor #1',
    src: '/video-4-frankie.mp4',
    fallbackSrc: '/video4frankie.mp4',
    poster: '/video-4-poster.jpg',
    posterJpg: '/video-4-poster.jpg',
    tag: 'Beach Swings',
    description: 'Children enjoying the colourful beach swing boats ride right beside Frankie’s TripAdvisor #1 banner on Ramsgate Sands.',
  },
  {
    id: 'video-5',
    number: 5,
    title: 'Frankie at the Beach — Video 5',
    subtitle: 'Foster’s Parasols & Beach Decking',
    src: '/video-5-frankie.mp4',
    fallbackSrc: '/video5frankie.mp4',
    poster: '/video-5-poster.jpg',
    posterJpg: '/video-5-poster.jpg',
    tag: 'Seaside Decking',
    description: 'Sunlit panoramic view of Frankie’s outdoor picnic tables with Foster’s umbrellas, seaside crowd, and the open Kent sea.',
  },
  {
    id: 'video-6',
    number: 6,
    title: 'Frankie at the Beach — Video 6',
    subtitle: 'Children’s Carousel & Beachfront Stroll',
    src: '/video-6-frankie.mp4',
    fallbackSrc: '/video6frankie.mp4',
    poster: '/video-6-poster.jpg',
    posterJpg: '/video-6-poster.jpg',
    tag: 'Kiddies Carousel',
    description: 'Mickey and Minnie Mouse carousel spinning on the sands beside Frankie’s kiosk, seaside promenade, and sunny beach vibes.',
  },
];

// Official TripAdvisor Review Links for Frankie's @ the Beach
export const TRIPADVISOR_LINKS = {
  restaurant: {
    title: "Frankie's Food Kiosk & Bar (Main)",
    shortTitle: "Food Kiosk & Bar (Main)",
    category: "Food Kiosk & Bar",
    badge: "Food & Bar",
    description: "Handcrafted 6oz burgers, proper seaside chips, promenade dogs & bar drinks",
    url: "https://www.tripadvisor.co.uk/Restaurant_Review-g186314-d32841312-Reviews-Frankies_At_The_Beach_Ramsgate-Ramsgate_Isle_of_Thanet_Kent_England.html",
  },
  attractions: {
    title: "Beach Rides & Kiddies Corner (Children)",
    shortTitle: "Beach Rides (Children)",
    category: "Attraction Review",
    badge: "Rides & Play",
    description: "Seaside carousel, giant inflatable slide & trampolines",
    url: "https://www.tripadvisor.co.uk/Attraction_Review-g186314-d33069310-Reviews-Frankies_At_The_Beach_Ramsgate-Ramsgate_Isle_of_Thanet_Kent_England.html",
  },
};

// Full TripAdvisor verified profiles data for both pages
export const TRIPADVISOR_PROFILES_DATA: Record<'restaurant' | 'attractions', TripAdvisorProfileData> = {
  restaurant: {
    id: 'tripadvisor-restaurant',
    title: "Frankie's At The Beach (The Main Page)",
    shortTitle: "Food Kiosk & Bar (Main)",
    tripadvisorId: "d32841312",
    location: "Kiosk 1, Marina Esplanade, Ramsgate CT11 8LS, Kent, England",
    rating: 4.9,
    reviewCount: 751,
    reviewCountLabel: "751 Reviews",
    rank: "#1 of 94 Quick Bites & Beach Dining in Ramsgate",
    subRatings: {
      "Food Quality": 4.9,
      "Service & Friendliness": 4.9,
      "Value for Money": 4.9,
      "Atmosphere & Sea Views": 4.9,
    },
    priceRange: "Seaside Food Kiosk & Bar",
    categories: ["Food Kiosk & Bar", "Quick Bites", "6oz Burgers", "Hot Dogs", "Loaded Chips", "Cold Drinks & Bar"],
    features: [
      "Seaside Beachfront Seating",
      "Direct Panoramic Royal Harbour Views",
      "6oz Prime Steak Burgers",
      "Proper Hand-Cut Seaside Chips with Salt & Vinegar",
      "Dog Friendly with Water Bowls",
      "Wheelchair & Pushchair Accessible",
      "Vegetarian & Halal-friendly Options",
      "Fast Friendly Service on the Sand",
    ],
    popularItems: [
      "6oz Beef Burger",
      "Bacon Cheese Burger",
      "Caribbean Chilli Cheese Burger",
      "The Footlong Frankfurter",
      "The Chilli Beef Dog",
      "Pepperoni & Cheese Loaded Fries",
      "Crispy French Fries",
    ],
    url: TRIPADVISOR_LINKS.restaurant.url,
    reviews: [
      {
        id: "ta-res-1",
        author: "Sarah & David M.",
        location: "London, UK",
        rating: 5,
        title: "Best burgers on the entire Kent coastline!",
        date: "Reviewed 3 weeks ago",
        visitType: "Visited with Family",
        comment: "Stopped by Frankie's while spending the day on Ramsgate main sands. The burgers are genuinely out of this world — crispy lacy edges on the beef, melted gooey cheese, and properly toasted brioche. The loaded fries were huge and kept our teenagers thrilled. Friendly team and you eat with your toes right in the sand!",
        helpfulVotes: 28,
        verified: true,
      },
      {
        id: "ta-res-2",
        author: "Marcus T.",
        location: "Canterbury, UK",
        rating: 5,
        title: "Pure seaside perfection — don't miss this gem",
        date: "Reviewed a month ago",
        visitType: "Visited with Friends",
        comment: "Don't let the beach kiosk look fool you: this is restaurant quality fast food. Fresh hot dogs with grilled onions and the chilli cheese sauce had the perfect kick. Great iced coffees too. Will be making this a regular pit stop every summer.",
        helpfulVotes: 21,
        verified: true,
      },
      {
        id: "ta-res-3",
        author: "Emma Watson-Brown",
        location: "Margate, UK",
        rating: 5,
        title: "Spotlessly clean, lightning fast service and smiling staff",
        date: "Reviewed 2 months ago",
        visitType: "Visited as a Couple",
        comment: "We sat on the picnic benches watching the tide come in while enjoying the bacon BBQ stack. Service was amazingly quick even though there was a queue on a sunny Saturday afternoon. The team working there never stop smiling. Well worth the 5-star TripAdvisor hype!",
        helpfulVotes: 35,
        verified: true,
      },
      {
        id: "ta-res-4",
        author: "Brian K.",
        location: "Maidstone, UK",
        rating: 5,
        title: "Delicious beach bites right on the sands",
        date: "Reviewed 2 months ago",
        visitType: "Solo Trip",
        comment: "Rode my motorcycle down from Maidstone for a morning beach bite. Fantastic quality ingredients and very reasonably priced compared to typical beachfront tourist traps. 5 stars all the way from me.",
        helpfulVotes: 16,
        verified: true,
      },
      {
        id: "ta-res-5",
        author: "Clare & Rob P.",
        location: "Tunbridge Wells, UK",
        rating: 5,
        title: "Loaded fries were sensational! Generous portions",
        date: "Reviewed 3 months ago",
        visitType: "Visited with Family",
        comment: "The chicken loaded fries were sensational! Generous portions that easily fed two of us. We also loved the seaside slushies on the hot sunny afternoon. Frankie's is a true staple of Ramsgate beach.",
        helpfulVotes: 29,
        verified: true,
      },
      {
        id: "ta-res-6",
        author: "Jonathan M.",
        location: "Bromley, UK",
        rating: 5,
        title: "Worth the trip down to Thanet just for Frankie’s",
        date: "Reviewed 4 months ago",
        visitType: "Visited with Family",
        comment: "We come to Ramsgate specifically because Frankie’s has the food sorted and the rides right next door. The kids eat well, play safely, and we get treated like family. 100% recommended on TripAdvisor.",
        helpfulVotes: 42,
        verified: true,
      },
    ],
  },
  attractions: {
    id: 'tripadvisor-attractions',
    title: "Frankie's Beach Rides & Kiddies Corner (The Children Page)",
    shortTitle: "Beach Rides & Play (Children)",
    tripadvisorId: "d33069310",
    location: "Kiosk 1, Marina Esplanade, Ramsgate Sands, Kent CT11 8LS, England",
    rating: 4.9,
    reviewCount: 270,
    reviewCountLabel: "270 Reviews",
    rank: "#1 Outdoor Children & Family Fun on Ramsgate Sands",
    subRatings: {
      "Fun & Excitement": 4.9,
      "Safety & Supervision": 4.9,
      "Value for Money": 4.9,
      "Attendant Friendliness": 4.9,
    },
    priceRange: "Ride Tokens & Multi-Packs Available on Site",
    categories: ["Fun & Games", "Amusement Rides", "Outdoor Family Activities", "Children Funfair", "Beach Attractions"],
    features: [
      "Full ADIPS Safety Inspected & Certified",
      "Attentive Trained Ride Marshalls on site",
      "Directly Adjacent to Frankie's Food Kiosk & Bar",
      "Soft Landing Safety Mats & Padded Harnesses",
      "Token Kiosks Accepting Cards & Cash",
      "Activities for Toddlers to Young Teens",
      "Panoramic Sea View Benches for Parents",
    ],
    popularItems: [
      "Giant Inflatable Ocean Slide",
      "Vintage Seaside Carousel Horses",
      "Bungee Beach Trampolines with Harness",
      "Kiddies Spinning Teacups",
      "Toddler Sand Play Safe Enclosure",
    ],
    url: TRIPADVISOR_LINKS.attractions.url,
    reviews: [
      {
        id: "ta-att-1",
        author: "Jessica H.",
        location: "London, UK",
        rating: 5,
        title: "Kept our 3 kids smiling and entertained for hours!",
        date: "Reviewed 2 weeks ago",
        visitType: "Visited with Family",
        comment: "Our 4, 7, and 9 year olds had an absolute blast on the giant inflatable slide and bungee trampolines. The ride operators were so gentle and patient with the younger ones. Tokens were very fair price and we felt completely safe with the safety mats and dedicated supervisors.",
        helpfulVotes: 38,
        verified: true,
      },
      {
        id: "ta-att-2",
        author: "Dean & Lucy G.",
        location: "Broadstairs, UK",
        rating: 5,
        title: "Classic seaside fun done to perfection",
        date: "Reviewed a month ago",
        visitType: "Visited with Family",
        comment: "The vintage carousel is beautiful and right next to Frankie's food kiosk, so mum and dad could sip iced lattes while keeping an eye on the children. Clean, well maintained and lovely coastal sea breeze. A highlight of Ramsgate beach.",
        helpfulVotes: 24,
        verified: true,
      },
      {
        id: "ta-att-3",
        author: "Priya Patel",
        location: "Ashford, UK",
        rating: 5,
        title: "Brilliant fun for toddlers and older kids alike",
        date: "Reviewed 2 months ago",
        visitType: "Visited with Family",
        comment: "We brought our toddler and 6-year-old nephew. Both had rides tailored to their ages. The trampolines with harnesses were a huge hit. Staff sanitize surfaces regularly and assist kids on and off every ride. Outstanding seaside attraction.",
        helpfulVotes: 31,
        verified: true,
      },
      {
        id: "ta-att-4",
        author: "Graham S.",
        location: "Ramsgate Local",
        rating: 5,
        title: "A true credit to Ramsgate seafront",
        date: "Reviewed 3 months ago",
        visitType: "Grandparents with Grandkids",
        comment: "As a local grandparent, taking the grandkids to Frankie’s beach rides is a weekly summer tradition. Clean, safe, and reasonably priced. The attendants are polite and attentive. Highly recommend to any families visiting Thanet.",
        helpfulVotes: 19,
        verified: true,
      },
      {
        id: "ta-att-5",
        author: "Sophie Collins",
        location: "Essex, UK",
        rating: 5,
        title: "Hours of pure seaside joy for the little ones",
        date: "Reviewed 3 months ago",
        visitType: "Holiday with Kids",
        comment: "The giant slide overlooking the ocean is magnificent! Kids could not stop smiling. It is so convenient being right on the sand next to the food kiosk. We will definitely be back next holiday.",
        helpfulVotes: 37,
        verified: true,
      },
      {
        id: "ta-att-6",
        author: "Oliver & Kelly R.",
        location: "Surrey, UK",
        rating: 5,
        title: "Safest and friendliest beach amusements we’ve visited",
        date: "Reviewed 4 months ago",
        visitType: "Visited with Family",
        comment: "The staff took extra time to ensure my daughter was strapped into the bungee trampoline comfortably and cheered her on. Top marks for safety and family friendliness.",
        helpfulVotes: 26,
        verified: true,
      },
    ],
  },
};


// The 4 Chef's Favourites shown on the home page:
export const CHEFS_FAVORITES: MenuItem[] = [
  {
    id: 'beef-burger',
    name: 'BEEF BURGER',
    price: 11.50,
    description: 'A 6oz juicy beef patty served in a brioche bun. Why not add salad, grilled onions and a sauce!',
    image: '/dishes/Beef Burger.webp',
    fallbackImage: '/dishes/Beef Burger.png',
    category: 'burgers',
    popular: true,
  },
  {
    id: 'pepperoni-cheese-loaded-fries',
    name: 'PEPPERONI LOADED FRIES WITH MELTED CHEESE',
    price: 7.95,
    description: 'Crispy fries loaded with your favorite topping with torched mature cheddar on the top so you can really taste the cheese ! Add one of our many toppings as well for a real treat.',
    image: '/dishes/pepperoni-cheese-loaded-fries.webp',
    fallbackImage: '/dishes/pepperoni-cheese-loaded-fries.png',
    category: 'loaded-fries',
    popular: true,
  },
  {
    id: 'bacon-cheese-burger',
    name: 'BACON CHEESE BURGER',
    price: 13.50,
    description: 'A juicy 6oz patty loaded with mature cheddar and thick danish bacon. Served, if you would like, on a bed of lettuce and tomato with onions in a brioche bun. We have lots of sauces to choose from too!',
    image: '/dishes/Bacon Cheese Burger.webp',
    fallbackImage: '/dishes/Bacon Cheese Burger.png',
    category: 'burgers',
    popular: true,
  },
  {
    id: 'the-footlong-frankfurter',
    name: 'THE FOOTLONG FRANKFURTER',
    price: 9.50,
    description: 'A delicious classic FrankFuter hotdog with a smoky flavour served in a soft brioche bun, why not add cheese and onion to make it simply perfect.',
    image: '/dishes/The Footlong Frankfurter.webp',
    fallbackImage: '/dishes/The Footlong Frankfurter.png',
    category: 'hot-dogs',
    popular: true,
  },
];

// Official Menu Categories & Items
export const MENU_CATEGORIES = [
  { id: 'all', label: 'All Items' },
  { id: 'burgers', label: '6oz Burgers' },
  { id: 'chicken-burgers', label: 'Chicken Burgers' },
  { id: 'fries', label: 'Fries' },
  { id: 'loaded-fries', label: 'Loaded Fries' },
  { id: 'hot-dogs', label: 'Hot Dogs' },
  { id: 'breakfast-rolls', label: 'Breakfast Rolls' },
  { id: 'donuts', label: 'Hot Fresh Donuts 🍩' },
  { id: 'drinks', label: 'Soft Drinks & Slushies' },
  { id: 'alcohol', label: 'Beach Bar & Alcohol 🍺' },
];

export const OFFICIAL_MENU: MenuItem[] = [
  // Breakfast Rolls
  {
    id: 'bacon-roll-3-rashers',
    name: 'Bacon Roll 3 Rashers',
    price: 7.95,
    description: '3 rashers of thick cut Danish bacon in a soft brioche roll. Why not accompany it with lettuce and tomatoes. The perfect start to the day!',
    image: '/dishes/Bacon Roll 3 Rashers.webp',
    fallbackImage: '/dishes/Bacon Roll 3 Rashers.webp',
    category: 'breakfast-rolls',
    popular: true,
  },
  {
    id: 'bacon-roll-topped-with-melted-cheese',
    name: 'Bacon Roll topped with Melted Cheese',
    price: 8.95,
    description: '3 rashers of thick cut Danish bacon in a soft brioche roll accompanied with melted mature cheddar cheese! The perfect start to the day!',
    image: '/dishes/Bacon Roll topped with Melted.webp',
    fallbackImage: '/dishes/Bacon Roll topped with Melted.webp',
    category: 'breakfast-rolls',
    popular: true,
  },
  {
    id: '3-rashers-of-bacon-with-2-eggs-in-roll',
    name: '3 Rashers of Bacon with 2 Eggs in Roll',
    price: 9.50,
    description: '3 rashers of thick cut Danish bacon in a soft brioche roll accompanied with 2 large free range eggs. The perfect start to the day!',
    image: '/dishes/3 Rashers of Bacon with 2 Eggs in Roll.webp',
    fallbackImage: '/dishes/3 Rashers of Bacon with 2 Eggs in Roll.webp',
    category: 'breakfast-rolls',
    popular: true,
  },
  {
    id: 'bacon-and-tomato-roll',
    name: 'Bacon and Tomato Roll',
    price: 8.50,
    description: '3 rashers of thick cut Danish bacon in a soft brioche roll accompanied with freshly sliced tomatoes. The perfect start to the day!',
    image: '/dishes/Bacon and Tomato Roll.webp',
    fallbackImage: '/dishes/Bacon and Tomato Roll.webp',
    category: 'breakfast-rolls',
    popular: true,
  },
  {
    id: 'bacon-lettuce-and-tomato-roll',
    name: 'Bacon, Lettuce and Tomato Roll',
    price: 10.00,
    description: '3 rashers of thick cut Danish bacon in a soft brioche roll accompanied with lettuce and tomatoes. The perfect start to the day with an absolute classic!',
    image: '/dishes/Bacon, Lettuce and Tomato Roll.webp',
    fallbackImage: '/dishes/Bacon, Lettuce and Tomato Roll.webp',
    category: 'breakfast-rolls',
    popular: true,
  },

  // 6oz Burgers
  {
    id: 'beef-burger',
    name: 'Beef Burger',
    price: 11.50,
    description: 'A 6oz juicy beef patty served in a brioche bun. Why not add salad, grilled onions and a sauce!',
    image: '/dishes/Beef Burger.webp',
    fallbackImage: '/dishes/Beef Burger.png',
    category: 'burgers',
    popular: true,
  },
  {
    id: 'bacon-cheese-burger',
    name: 'Bacon Cheese Burger',
    price: 13.50,
    description: 'A juicy 6oz patty loaded with mature cheddar and thick danish bacon. Served, if you would like, on a bed of lettuce and tomato with onions in a brioche bun. We have lots of sauces to choose from too!',
    image: '/dishes/Bacon Cheese Burger.webp',
    fallbackImage: '/dishes/Bacon Cheese Burger.png',
    category: 'burgers',
    popular: true,
  },
  {
    id: 'caribbean-chilli-cheese-burger',
    name: 'Caribbean Chilli Cheese Burger',
    price: 13.95,
    description: 'A juicy 6oz patty loaded with mature cheddar and an American slice! Served, if you would like, on a bed of lettuce & tomato and grilled onions in a brioche bun. Topped off with our delicious Caribbean pepper sauce',
    image: '/dishes/Caribbean Chilli Cheese Burger.webp',
    fallbackImage: '/dishes/Caribbean Chilli Cheese Burger.png',
    category: 'burgers',
    spicyLevel: 2,
    popular: true,
  },
  {
    id: 'double-egg-cheese-burger',
    name: 'Double Egg Cheese Burger',
    price: 13.95,
    description: 'A juicy 6oz patty loaded with mature cheddar and two large free range eggs. Served, if you would like, on a bed of lettuce & tomato and grilled onions in a brioche bun. We have lots of sauces to choose from too!',
    image: '/dishes/Double Egg Cheese Burger.webp',
    fallbackImage: '/dishes/Double Egg Cheese Burger.png',
    category: 'burgers',
    popular: true,
  },
  {
    id: 'stilton-cheese-bacon-burger',
    name: 'Stilton Cheese Bacon Burger',
    price: 14.50,
    description: 'A juicy 6oz patty topped with melted Stilton and thick Danish bacon. Served, if you would like, on a bed of lettuce & tomato and grilled onions in a brioche bun. We have lots of sauces to choose from too!',
    image: '/dishes/Stilton Cheese Bacon Burger.webp',
    fallbackImage: '/dishes/Stilton Cheese Bacon Burger.png',
    category: 'burgers',
    popular: true,
  },
  {
    id: 'supreme-veggie-burger',
    name: 'Supreme Veggie Burger',
    price: 11.95,
    description: 'A delicious alternative for vegetarians. We serve our burger on a brioche bun. Why not add lettuce, tomato and grilled onions to complete! We have a large range of sauces too for you.',
    image: '/dishes/Supreme Veggie Burger.webp',
    fallbackImage: '/dishes/Supreme Veggie Burger.png',
    category: 'burgers',
    vegetarian: true,
    spicyLevel: 1,
    popular: true,
  },

  // Chicken Burgers
  {
    id: 'chicken-cheese-burger',
    name: 'Chicken Burger',
    price: 12.50,
    description: 'A large butter milk chicken fillet served in a brioche bun! Why not add lettuce, tomato and grilled onions to make it that bit more special! There are lots of sauces to choose from aswell',
    image: '/dishes/Chicken Cheese Burger.webp',
    fallbackImage: '/dishes/Chicken Cheese Burger.png',
    category: 'chicken-burgers',
    popular: true,
  },
  {
    id: 'caribbean-chicken-and-cheese-burger',
    name: 'Caribbean Chicken and Cheese',
    price: 13.95,
    description: 'A large butter milk chicken fillet served in a brioche bun with the delicious Caribbean pepper sauce and melted mature cheddar! Why not add lettuce, tomato and grilled onions to make it that bit more special! There are lots of sauces to choose from aswell',
    image: '/dishes/Caribbean Chilli Cheese Burger.webp',
    fallbackImage: '/dishes/Caribbean Chilli Cheese Burger.png',
    category: 'chicken-burgers',
    spicyLevel: 2,
    popular: true,
  },
  {
    id: 'chicken-jack-burger',
    name: 'Chicken Cheese jack Burger',
    price: 13.95,
    description: 'A large butter milk chicken fillet served in a brioche bun with the famous Jack Daniels sauce and melted mature cheddar! Why not add lettuce, tomato and grilled onions to make it that bit more special! There are lots of sauces to choose from aswell',
    image: '/dishes/Chicken Jack Burger.webp',
    fallbackImage: '/dishes/Chicken Jack Burger.png',
    category: 'chicken-burgers',
    popular: true,
  },
  {
    id: 'venison-burger',
    name: 'Venison Burger',
    price: 14.95,
    description: '2 juicy venison patties loaded with mature cheddar. Served on a bed of lettuce and tomato in a brioche bun. Locally sourced meat make it a firm favourite of ours !',
    image: '/dishes/Venison Burger.webp',
    fallbackImage: '/dishes/Venison Burger.png',
    category: 'chicken-burgers',
    popular: true,
  },

  // Tab 1: Fries
  {
    id: 'large-fries',
    name: 'Large Fries',
    price: 4.50,
    description: 'A large box of crispy skin on fries. These fries are so popular ! Great taste and great portion size',
    image: '/dishes/cheesy-fries.webp',
    fallbackImage: '/dishes/cheesy-fries.png',
    category: 'fries',
    vegetarian: true,
    popular: true,
  },
  {
    id: 'large-cheesy-fries',
    name: 'Large Cheesy Fries',
    price: 5.95,
    description: 'A large box of crispy skin on fries. These fries are so popular ! Great taste and great portion size With melted mature cheddar melted on the top. Why not pick one of our many sauces too!',
    image: '/dishes/cheesy-fries.webp',
    fallbackImage: '/dishes/cheesy-fries.png',
    category: 'fries',
    vegetarian: true,
    popular: true,
  },

  // Tab 2: Loaded Fries
  {
    id: 'pepperoni-cheese-loaded-fries',
    name: 'Pepperoni Loaded Fries with Melted Cheese',
    price: 7.95,
    description: 'Crispy fries loaded with your favorite topping with torched mature cheddar on the top so you can really taste the cheese ! Add one of our many toppings as well for a real treat.',
    image: '/dishes/pepperoni-cheese-loaded-fries.webp',
    fallbackImage: '/dishes/pepperoni-cheese-loaded-fries.png',
    category: 'loaded-fries',
    popular: true,
  },
  {
    id: 'bacon-cheese-loaded-fries',
    name: 'Bacon and Cheese Loaded Fries',
    price: 7.95,
    description: 'Crispy fries loaded with your favorite topping with torched mature cheddar on the top so you can really taste the cheese ! Add one of our many toppings as well for a real treat.',
    image: '/dishes/cheesy-fries.webp',
    fallbackImage: '/dishes/cheesy-fries.png',
    category: 'loaded-fries',
    popular: true,
  },
  {
    id: 'fish-fingers-cheese-loaded-fries',
    name: 'Fish Finger and Cheese Loaded Fries',
    price: 8.50,
    description: 'Crispy fries loaded with your favorite topping with torched mature cheddar on the top so you can really taste the cheese ! Add one of our many toppings as well for a real treat.',
    image: '/dishes/fish-fingers-cheese-loaded-fries.webp',
    fallbackImage: '/dishes/fish-fingers-cheese-loaded-fries.png',
    category: 'loaded-fries',
    popular: true,
  },
  {
    id: 'southern-fried-chicken-cheese-loaded-fries',
    name: 'Southern Fried Chicken Loaded Fries',
    price: 8.95,
    description: 'Crispy fries loaded with your favorite topping with torched mature cheddar on the top so you can really taste the cheese ! Add one of our many toppings as well for a real treat.',
    image: '/dishes/southern-fried-chicken-cheese-loaded-fries.webp',
    fallbackImage: '/dishes/southern-fried-chicken-cheese-loaded-fries.png',
    category: 'loaded-fries',
    popular: true,
  },

  // Hot Dogs
  {
    id: 'the-footlong-frankfurter',
    name: 'The Footlong Frankfurter',
    price: 9.50,
    description: 'A delicious classic FrankFuter hotdog with a smoky flavour served in a soft brioche bun, why not add cheese and onion to make it simply perfect.',
    image: '/dishes/The Footlong Frankfurter.webp',
    fallbackImage: '/dishes/The Footlong Frankfurter.png',
    category: 'hot-dogs',
    popular: true,
  },
  {
    id: 'the-footlong-bratwurst',
    name: 'The Footlong Bratwurst',
    price: 9.95,
    description: 'A huge German bratwurst hotdog cooked to perfection, served in a soft brioche bun, why not add cheese and onion to make it simply perfect.',
    image: '/dishes/The Footlong Frankfurter.webp',
    fallbackImage: '/dishes/The Footlong Frankfurter.png',
    category: 'hot-dogs',
    popular: true,
  },
  {
    id: 'the-lincolnshire-long-dog',
    name: 'The Lincolnshire Long Dog',
    price: 9.50,
    description: 'A British banger filled with a blend of herbs and spices, served in a soft brioche bun, why not add cheese and onion to make it simply perfect.',
    image: '/dishes/The Lincolnshire Long Dog.webp',
    fallbackImage: '/dishes/The Lincolnshire Long Dog.png',
    category: 'hot-dogs',
    popular: true,
  },
  {
    id: 'the-chilli-beef-dog',
    name: 'The Chilli Beef Dog',
    price: 10.50,
    description: 'Packed full of flavours this sightly spicy dog will get your tastebuds tingling, served in a soft brioche bun, why not add cheese and onion to make it simply perfect.',
    image: '/dishes/The Footlong Frankfurter.webp',
    fallbackImage: '/dishes/The Footlong Frankfurter.png',
    category: 'hot-dogs',
    spicyLevel: 2,
    popular: true,
  },

  // Drinks / Slushies
  {
    id: 'strawberry-slushy-568ml',
    name: 'Strawberry Slushy 568ml',
    price: 4.50,
    description: 'Our slushies are so popular! A premium slush mix and great flavours that offer a refreshing alternative to have with your food.',
    image: '/dishes/Strawberry Slushy 568ml.webp',
    fallbackImage: '/dishes/Strawberry Slushy 568ml.webp',
    category: 'drinks',
    popular: true,
    vegetarian: true,
  },
  {
    id: 'raspberry-slushy-568ml',
    name: 'Raspberry Slushy 568ml',
    price: 4.50,
    description: 'Our slushies are so popular! A premium slush mix and great flavours that offer a refreshing alternative to have with your food.',
    image: '/dishes/Raspberry Slushy 568ml.webp',
    fallbackImage: '/dishes/Raspberry Slushy 568ml.webp',
    category: 'drinks',
    popular: true,
    vegetarian: true,
  },
  {
    id: 'sour-cherry-slushy-568ml',
    name: 'Sour Cherry slushy 568ml',
    price: 4.50,
    description: 'Our slushies are so popular! A premium slush mix and great flavours that offer a refreshing alternative to have with your food.',
    image: '/dishes/Sour Cherry slushy 568ml.webp',
    fallbackImage: '/dishes/Sour Cherry slushy 568ml.webp',
    category: 'drinks',
    popular: true,
    vegetarian: true,
  },
  {
    id: 'coca-cola-slushy-568ml',
    name: 'Coca-Cola Slushy 568ml',
    price: 4.50,
    description: 'Our slushies are so popular! A premium slush mix and great flavours that offer a refreshing alternative to have with your food.',
    image: '/dishes/Coca-Cola Slushy 568ml.webp',
    fallbackImage: '/dishes/Coca-Cola Slushy 568ml.webp',
    category: 'drinks',
    popular: true,
    vegetarian: true,
  },
  {
    id: 'lemon-and-lime-slushy-568ml',
    name: 'Lemon and Lime Slushy 568ml',
    price: 4.50,
    description: 'Our slushies are so popular! A premium slush mix and great flavours that offer a refreshing alternative to have with your food.',
    image: '/dishes/Lemon and Lime Slushy 568ml.webp',
    fallbackImage: '/dishes/Lemon and Lime Slushy 568ml.webp',
    category: 'drinks',
    popular: true,
    vegetarian: true,
  },
  {
    id: 'apple-mango-slushy-568ml',
    name: 'Apple & mango Slushy 568ml',
    price: 4.50,
    description: 'Our slushies are so popular! A premium slush mix and great flavours that offer a refreshing alternative to have with your food.',
    image: APPLE_MANGO_SLUSHY_DATA_URI,
    fallbackImage: '/dishes/Apple and Mango Slushy 568ml.webp',
    category: 'drinks',
    popular: true,
    vegetarian: true,
  },

  // ==========================================
  // BEACH BAR & ALCOHOL
  // ==========================================
  // Beer & Cider on Tap
  {
    id: 'cruzcampo-draught-pint',
    name: 'Cruzcampo Draught Pint',
    price: 5.80,
    description: 'Fresh, cold Spanish draught lager poured with a smooth, velvety white foam and clean, crisp malt finish.',
    image: '/drinks/cruzcampo-pint.webp',
    fallbackImage: '/drinks/cruzcampo-pint.jpg',
    category: 'alcohol',
    subCategory: 'Beer & Cider on Tap',
    servingSize: '568ml Pint',
    popular: true,
    vegetarian: true,
  },
  {
    id: 'fosters-draught-pint',
    name: 'Fosters Draught Pint',
    price: 5.00,
    description: 'Classic crisp, refreshing golden lager brewed for pure seaside drinkability. Ice-cold on tap with a clean finish.',
    image: '/drinks/fosters-pint.webp',
    fallbackImage: '/drinks/fosters-pint.jpg',
    category: 'alcohol',
    subCategory: 'Beer & Cider on Tap',
    servingSize: '568ml Pint',
    popular: true,
    vegetarian: true,
  },
  {
    id: 'strongbow-draught-pint',
    name: 'Strongbow Cider Pint',
    price: 5.20,
    description: 'Crisp, thirst-quenching British apple cider poured fresh from the tap. Refreshingly dry and sparkling with bright orchard flavours.',
    image: '/drinks/strongbow-cider.webp',
    fallbackImage: '/drinks/strongbow-cider.jpg',
    category: 'alcohol',
    subCategory: 'Beer & Cider on Tap',
    servingSize: '568ml Pint',
    popular: true,
    vegetarian: true,
  },

  // Cans & Bottles
  {
    id: 'birra-moretti-bottle',
    name: 'Birra Moretti (330ml)',
    price: 4.90,
    description: 'Authentic Italian premium quality lager made with finely balanced hops and barley. Smooth, aromatic, and deeply refreshing.',
    image: '/drinks/birra-moretti.webp',
    fallbackImage: '/drinks/birra-moretti.jpg',
    category: 'alcohol',
    subCategory: 'Cans & Bottles',
    servingSize: '330ml Bottle',
    popular: true,
    vegetarian: true,
  },
  {
    id: 'peroni-nastro-azzurro-bottle',
    name: 'Peroni Nastro Azzurro (330ml)',
    price: 4.90,
    description: 'Crisp and effervescent premium Italian beer brewed with exclusive Nostrano dell\'Isola maize for a clean, sparkling Mediterranean bite.',
    image: '/drinks/peroni-bottle.webp',
    fallbackImage: '/drinks/peroni-bottle.jpg',
    category: 'alcohol',
    subCategory: 'Cans & Bottles',
    servingSize: '330ml Bottle',
    popular: true,
    vegetarian: true,
  },

  // Spirits
  {
    id: 'premium-vodka-mixer',
    name: 'Vodka & Mixer',
    price: 5.50,
    description: 'Triple-distilled crystal clear smooth grain vodka served over copious ice with fresh lime and your choice of mixer.',
    image: '/drinks/vodka-mixer.webp',
    fallbackImage: '/drinks/vodka-mixer.jpg',
    category: 'alcohol',
    subCategory: 'Spirits',
    servingSize: '25ml Single / Mixer',
    popular: false,
    vegetarian: true,
  },
  {
    id: 'malibu-coconut-rum',
    name: 'Malibu Coconut Rum',
    price: 5.50,
    description: 'Sweet Caribbean rum infused with natural coconut flavor. Best paired with chilled pineapple juice or sparkling cola.',
    image: '/drinks/malibu-coconut.webp',
    fallbackImage: '/drinks/malibu-coconut.jpg',
    category: 'alcohol',
    subCategory: 'Spirits',
    servingSize: '25ml Single / Mixer',
    popular: false,
    vegetarian: true,
  },
  {
    id: 'caribbean-spiced-rum',
    name: 'Caribbean Spiced Rum',
    price: 5.80,
    description: 'Warm golden rum expertly blended with natural island spices, notes of rich vanilla, and caramel. Outstanding with ginger beer or cola.',
    image: '/drinks/spiced-rum.webp',
    fallbackImage: '/drinks/spiced-rum.jpg',
    category: 'alcohol',
    subCategory: 'Spirits',
    servingSize: '25ml Single / Mixer',
    popular: true,
    vegetarian: true,
  },
  {
    id: 'fine-blended-whiskey',
    name: 'Fine Blended Whiskey',
    price: 5.80,
    description: 'Rich oak-matured blended whiskey served neat, on the rocks, or lengthened with crisp dry ginger ale.',
    image: '/drinks/whiskeys.webp',
    fallbackImage: '/drinks/whiskeys.jpg',
    category: 'alcohol',
    subCategory: 'Spirits',
    servingSize: '25ml Single',
    popular: false,
    vegetarian: true,
  },
  {
    id: 'jack-daniels-whiskey',
    name: 'Jack Daniel\'s Tennessee Whiskey',
    price: 5.90,
    description: 'Charcoal-mellowed Old No. 7 Tennessee whiskey with sweet caramel and toasted oak notes. Served over ice or with ice-cold Coca-Cola.',
    image: '/drinks/jack-daniels.webp',
    fallbackImage: '/drinks/jack-daniels.jpg',
    category: 'alcohol',
    subCategory: 'Spirits',
    servingSize: '25ml Single / Mixer',
    popular: true,
    vegetarian: true,
  },
  {
    id: 'pink-gin-tonic',
    name: 'Pink Gin & Tonic',
    price: 6.20,
    description: 'Vibrant strawberry and redcurrant infused pink gin mixed with Mediterranean tonic, ice, and fresh summer berry garnish.',
    image: '/drinks/pink-gin.webp',
    fallbackImage: '/drinks/pink-gin.jpg',
    category: 'alcohol',
    subCategory: 'Spirits',
    servingSize: 'Copa Glass / Tonic',
    popular: true,
    vegetarian: true,
  },
  {
    id: 'classic-gin-tonic',
    name: 'Classic London Dry Gin',
    price: 5.80,
    description: 'Aromatic juniper-forward botanical gin poured over ice, topped with crisp Indian tonic and a wedge of fresh coastal lime.',
    image: '/drinks/gin-tonic.webp',
    fallbackImage: '/drinks/gin-tonic.jpg',
    category: 'alcohol',
    subCategory: 'Spirits',
    servingSize: '25ml Single / Tonic',
    popular: false,
    vegetarian: true,
  },
  {
    id: 'disaronno-amaretto',
    name: 'Disaronno Originale',
    price: 5.80,
    description: 'The iconic Italian amber liqueur with velvety bittersweet almond notes. Served on the rocks or with refreshing cola and fresh lemon.',
    image: '/drinks/disaronno.webp',
    fallbackImage: '/drinks/disaronno.jpg',
    category: 'alcohol',
    subCategory: 'Spirits',
    servingSize: '25ml / Rocks or Mixer',
    popular: false,
    vegetarian: true,
  },
  {
    id: 'italian-sambuca',
    name: 'Italian Sambuca',
    price: 4.50,
    description: 'Classic Italian aniseed liqueur with sweet herbal intensity and warm finish. Served chilled as a lively seaside shot.',
    image: '/drinks/sambuca.webp',
    fallbackImage: '/drinks/sambuca.jpg',
    category: 'alcohol',
    subCategory: 'Spirits',
    servingSize: '25ml Chilled Shot',
    popular: false,
    vegetarian: true,
  },
  {
    id: 'bacardi-carta-blanca',
    name: 'Bacardi Carta Blanca Rum',
    price: 5.50,
    description: 'Smooth, light white rum aged in white oak barrels with subtle almond and floral fruit notes. Ideal with chilled Coca-Cola and lime.',
    image: '/drinks/bacardi.webp',
    fallbackImage: '/drinks/bacardi.jpg',
    category: 'alcohol',
    subCategory: 'Spirits',
    servingSize: '25ml Single / Mixer',
    popular: false,
    vegetarian: true,
  },

  // Cocktails
  {
    id: 'strawberry-daiquiri-cocktail',
    name: 'Strawberry Daiquiri',
    price: 8.50,
    description: 'Sweet summer strawberries, white rum, fresh squeezed lime juice, and crushed ice blended into a thick, vibrant frozen beach cocktail.',
    image: '/drinks/strawberry-daiquiri.webp',
    fallbackImage: '/drinks/strawberry-daiquiri.jpg',
    category: 'alcohol',
    subCategory: 'Cocktails',
    servingSize: 'Cocktail Glass',
    popular: true,
    vegetarian: true,
  },
  {
    id: 'espresso-martini-cocktail',
    name: 'Espresso Martini',
    price: 8.95,
    description: 'A vigorous shake of freshly brewed espresso, premium vodka, and velvety coffee liqueur topped with a thick, frothy crema and roasted coffee beans.',
    image: '/drinks/espresso-martini.webp',
    fallbackImage: '/drinks/espresso-martini.jpg',
    category: 'alcohol',
    subCategory: 'Cocktails',
    servingSize: 'Chilled Coupette',
    popular: true,
    vegetarian: true,
  },
  {
    id: 'pina-colada-cocktail',
    name: 'Piña Colada',
    price: 8.50,
    description: 'Rich coconut cream, tropical pineapple juice, and smooth white rum blended to frozen creamy perfection. Topped with fresh fruit garnish.',
    image: '/drinks/pina-colada.webp',
    fallbackImage: '/drinks/pina-colada.jpg',
    category: 'alcohol',
    subCategory: 'Cocktails',
    servingSize: 'Hurricane Glass',
    popular: true,
    vegetarian: true,
  },

  // Prosecco & Wine
  {
    id: 'prosecco-doc-glass-bottle',
    name: 'Prosecco DOC (Glass or Bottle)',
    price: 6.50,
    description: 'Crisp, refreshing Italian sparkling Prosecco featuring delicate aromas of green apples, acacia flowers, and persistent lively bubbles.',
    image: '/drinks/prosecco.webp',
    fallbackImage: '/drinks/prosecco.jpg',
    category: 'alcohol',
    subCategory: 'Prosecco & Wine',
    servingSize: 'Available by the Flute or Full Bottle',
    popular: true,
    vegetarian: true,
  },
  {
    id: 'seaside-wine-selection',
    name: 'Seaside Wine Selection (Glass or Bottle)',
    price: 5.50,
    description: 'Your choice of crisp chilled Pinot Grigio, refreshing summer Rosé, or smooth Chilean Merlot. Available by the glass or full bottle.',
    image: '/drinks/wine-selection.webp',
    fallbackImage: '/drinks/wine-selection.jpg',
    category: 'alcohol',
    subCategory: 'Prosecco & Wine',
    servingSize: 'Available by the 175ml Glass or Full Bottle',
    popular: false,
    vegetarian: true,
  },

  // ==========================================
  // FRANKIE'S HOT DONUTS COLLECTION
  // ==========================================
  // 1. Plain With Sugar (2, 5, 10)
  {
    id: 'hot-donuts-plain-2',
    name: 'Hot Donuts - Plain with Sugar (2 Donuts)',
    price: 3.50,
    description: '2 hot, freshly fried ring donuts tossed in sweet granulated sugar. Made fresh right at the kiosk on Ramsgate beach!',
    image: '/donuts/donuts-plain-2.webp',
    fallbackImage: '/donuts/donuts-plain-2.jpg',
    category: 'donuts',
    subCategory: 'Plain with Sugar',
    servingSize: '2 Fresh Hot Donuts',
    popular: true,
    vegetarian: true,
  },
  {
    id: 'hot-donuts-plain-5',
    name: 'Hot Donuts - Plain with Sugar (5 Donuts)',
    price: 6.50,
    description: '5 hot, freshly fried ring donuts tossed in sweet granulated sugar. Perfect for sharing with friends on the promenade.',
    image: '/donuts/donuts-plain-5.webp',
    fallbackImage: '/donuts/donuts-plain-5.jpg',
    category: 'donuts',
    subCategory: 'Plain with Sugar',
    servingSize: '5 Fresh Hot Donuts',
    popular: true,
    vegetarian: true,
  },
  {
    id: 'hot-donuts-plain-10',
    name: 'Hot Donuts - Plain with Sugar (10 Donuts)',
    price: 11.00,
    description: '10 hot, freshly fried ring donuts tossed in sweet granulated sugar. Generous family seaside sharing box!',
    image: '/donuts/donuts-plain-10.webp',
    fallbackImage: '/donuts/donuts-plain-10.jpg',
    category: 'donuts',
    subCategory: 'Plain with Sugar',
    servingSize: '10 Fresh Hot Donuts (Family Box)',
    popular: true,
    vegetarian: true,
  },

  // 2. Combos with Soft Serve Ice Cream
  {
    id: 'hot-donuts-ice-cream-toppings-2',
    name: '2 with Ice Cream & Toppings',
    price: 5.50,
    description: '2 warm, freshly fried donuts served with creamy vanilla soft-serve ice cream and your choice of delicious toppings and drizzles.',
    image: '/donuts/donuts-ice-cream-toppings.webp',
    fallbackImage: '/donuts/donuts-ice-cream-toppings.jpg',
    category: 'donuts',
    subCategory: 'Ice Cream Combos',
    servingSize: '2 Donuts + Ice Cream & Toppings',
    popular: true,
    vegetarian: true,
  },
  {
    id: 'hot-donuts-ice-cream-sauce-2',
    name: '2 with Ice Cream & Sauce',
    price: 4.95,
    description: '2 warm, freshly fried donuts paired with creamy soft-serve vanilla ice cream and your choice of signature dessert sauce.',
    image: '/donuts/donuts-ice-cream-sauce.webp',
    fallbackImage: '/donuts/donuts-ice-cream-sauce.jpg',
    category: 'donuts',
    subCategory: 'Ice Cream Combos',
    servingSize: '2 Donuts + Ice Cream & Sauce',
    popular: true,
    vegetarian: true,
  },

  // 3. The 20 Specialty 2 TOPPED DONUTS Flavors
  {
    id: 'donuts-marshmallow',
    name: '2 Marshmallow TOPPED Donuts',
    price: 5.50,
    description: '2 hot fresh donuts topped with fluffy pink & white mini marshmallows, creamy soft-serve, and sweet dessert syrup.',
    image: '/donuts/donuts-marshmallow.webp',
    fallbackImage: '/donuts/donuts-marshmallow.jpg',
    category: 'donuts',
    subCategory: 'Topped Donuts',
    servingSize: '2 Topped Donuts',
    popular: true,
    vegetarian: true,
  },
  {
    id: 'donuts-sprinkle',
    name: '2 Sprinkle TOPPED Donuts',
    price: 5.50,
    description: '2 hot fresh donuts covered in colorful carnival rainbow sprinkles, creamy soft-serve swirl, and sweet fruit syrup.',
    image: '/donuts/donuts-sprinkle.webp',
    fallbackImage: '/donuts/donuts-sprinkle.jpg',
    category: 'donuts',
    subCategory: 'Topped Donuts',
    servingSize: '2 Topped Donuts',
    popular: true,
    vegetarian: true,
  },
  {
    id: 'donuts-biscoff',
    name: '2 Lotus Biscoff TOPPED Donuts',
    price: 5.50,
    description: '2 hot fresh donuts loaded with crumbled Lotus Biscoff biscuits, soft-serve ice cream, and rich spiced speculoos caramel sauce.',
    image: '/donuts/donuts-biscoff.webp',
    fallbackImage: '/donuts/donuts-biscoff.jpg',
    category: 'donuts',
    subCategory: 'Topped Donuts',
    servingSize: '2 Topped Donuts',
    popular: true,
    vegetarian: true,
  },
  {
    id: 'donuts-oreo',
    name: '2 OREO TOPPED Donuts',
    price: 5.50,
    description: '2 hot fresh donuts piled high with crushed chocolate Oreo cookie pieces, creamy vanilla soft-serve, and dark chocolate drizzle.',
    image: '/donuts/donuts-oreo.webp',
    fallbackImage: '/donuts/donuts-oreo.jpg',
    category: 'donuts',
    subCategory: 'Topped Donuts',
    servingSize: '2 Topped Donuts',
    popular: true,
    vegetarian: true,
  },
  {
    id: 'donuts-after-eight',
    name: '2 After Eight TOPPED Donuts',
    price: 5.50,
    description: '2 hot fresh donuts smothered in refreshing mint syrup, rich dark chocolate drizzle, and creamy soft-serve ice cream.',
    image: '/donuts/donuts-after-eight.webp',
    fallbackImage: '/donuts/donuts-after-eight.jpg',
    category: 'donuts',
    subCategory: 'Topped Donuts',
    servingSize: '2 Topped Donuts',
    popular: false,
    vegetarian: true,
  },
  {
    id: 'donuts-strawberry',
    name: '2 Strawberry TOPPED Donuts',
    price: 5.50,
    description: '2 hot fresh donuts drizzled with sweet seaside strawberry fruit coulis, strawberry syrup, and creamy soft-serve swirl.',
    image: '/donuts/donuts-strawberry.webp',
    fallbackImage: '/donuts/donuts-strawberry.jpg',
    category: 'donuts',
    subCategory: 'Topped Donuts',
    servingSize: '2 Topped Donuts',
    popular: true,
    vegetarian: true,
  },
  {
    id: 'donuts-bubblegum',
    name: '2 Bubblegum TOPPED Donuts',
    price: 5.50,
    description: '2 hot fresh donuts drizzled with vibrant electric-blue retro bubblegum syrup and creamy soft-serve ice cream. A seaside funfair classic!',
    image: '/donuts/donuts-bubblegum.webp',
    fallbackImage: '/donuts/donuts-bubblegum.jpg',
    category: 'donuts',
    subCategory: 'Topped Donuts',
    servingSize: '2 Topped Donuts',
    popular: true,
    vegetarian: true,
  },
  {
    id: 'donuts-lime',
    name: '2 Lime TOPPED Donuts',
    price: 5.50,
    description: '2 hot fresh donuts with a zesty splash of tangy green lime dessert syrup paired with creamy soft-serve swirl.',
    image: '/donuts/donuts-lime.webp',
    fallbackImage: '/donuts/donuts-lime.jpg',
    category: 'donuts',
    subCategory: 'Topped Donuts',
    servingSize: '2 Topped Donuts',
    popular: false,
    vegetarian: true,
  },
  {
    id: 'donuts-candy-floss',
    name: '2 Candy Floss TOPPED Donuts',
    price: 5.50,
    description: '2 hot fresh donuts drizzled with nostalgic sweet pink seaside candy floss syrup and creamy soft-serve ice cream.',
    image: '/donuts/donuts-candy-floss.webp',
    fallbackImage: '/donuts/donuts-candy-floss.jpg',
    category: 'donuts',
    subCategory: 'Topped Donuts',
    servingSize: '2 Topped Donuts',
    popular: true,
    vegetarian: true,
  },
  {
    id: 'donuts-dr-pepper',
    name: '2 Dr Pepper TOPPED Donuts',
    price: 5.50,
    description: '2 hot fresh donuts drizzled with distinctive Dr Pepper spiced cherry soda syrup and creamy soft-serve swirl.',
    image: '/donuts/donuts-dr-pepper.webp',
    fallbackImage: '/donuts/donuts-dr-pepper.jpg',
    category: 'donuts',
    subCategory: 'Topped Donuts',
    servingSize: '2 Topped Donuts',
    popular: false,
    vegetarian: true,
  },
  {
    id: 'donuts-vimto',
    name: '2 Vimto TOPPED Donuts',
    price: 5.50,
    description: '2 hot fresh donuts drenched in classic fruity Vimto berry and blackcurrant syrup with creamy soft-serve ice cream.',
    image: '/donuts/donuts-vimto.webp',
    fallbackImage: '/donuts/donuts-vimto.jpg',
    category: 'donuts',
    subCategory: 'Topped Donuts',
    servingSize: '2 Topped Donuts',
    popular: true,
    vegetarian: true,
  },
  {
    id: 'donuts-banoffee',
    name: '2 Banoffee TOPPED Donuts',
    price: 5.50,
    description: '2 hot fresh donuts layered with sweet banana drizzle, golden sticky toffee caramel sauce, and creamy soft-serve.',
    image: '/donuts/donuts-banoffee.webp',
    fallbackImage: '/donuts/donuts-banoffee.jpg',
    category: 'donuts',
    subCategory: 'Topped Donuts',
    servingSize: '2 Topped Donuts',
    popular: true,
    vegetarian: true,
  },
  {
    id: 'donuts-mango',
    name: '2 Mango TOPPED Donuts',
    price: 5.50,
    description: '2 hot fresh donuts drizzled with exotic tropical mango fruit coulis and creamy soft-serve ice cream.',
    image: '/donuts/donuts-mango.webp',
    fallbackImage: '/donuts/donuts-mango.jpg',
    category: 'donuts',
    subCategory: 'Topped Donuts',
    servingSize: '2 Topped Donuts',
    popular: false,
    vegetarian: true,
  },
  {
    id: 'donuts-jaffa-cakes',
    name: '2 Jaffa Cakes TOPPED Donuts',
    price: 5.50,
    description: '2 hot fresh donuts drizzled with tangy orange zest syrup and rich dark chocolate sauce with creamy soft-serve.',
    image: '/donuts/donuts-jaffa-cakes.webp',
    fallbackImage: '/donuts/donuts-jaffa-cakes.jpg',
    category: 'donuts',
    subCategory: 'Topped Donuts',
    servingSize: '2 Topped Donuts',
    popular: true,
    vegetarian: true,
  },
  {
    id: 'donuts-red-bull',
    name: '2 Red Bull TOPPED Donuts',
    price: 5.50,
    description: '2 hot fresh donuts drizzled with signature sweet Red Bull energy golden syrup and soft-serve ice cream.',
    image: '/donuts/donuts-red-bull.webp',
    fallbackImage: '/donuts/donuts-red-bull.jpg',
    category: 'donuts',
    subCategory: 'Topped Donuts',
    servingSize: '2 Topped Donuts',
    popular: false,
    vegetarian: true,
  },
  {
    id: 'donuts-peanut-chocolate',
    name: '2 Peanut & Chocolate TOPPED Donuts',
    price: 5.50,
    description: '2 hot fresh donuts loaded with rich peanut butter swirl, decadent chocolate sauce, and creamy soft-serve.',
    image: '/donuts/donuts-peanut-chocolate.webp',
    fallbackImage: '/donuts/donuts-peanut-chocolate.jpg',
    category: 'donuts',
    subCategory: 'Topped Donuts',
    servingSize: '2 Topped Donuts',
    popular: true,
    vegetarian: true,
  },
  {
    id: 'donuts-skittles',
    name: '2 Skittles TOPPED Donuts',
    price: 5.50,
    description: '2 hot fresh donuts covered in tangy multi-fruit Skittles syrup and creamy soft-serve ice cream.',
    image: '/donuts/donuts-skittles.webp',
    fallbackImage: '/donuts/donuts-skittles.jpg',
    category: 'donuts',
    subCategory: 'Topped Donuts',
    servingSize: '2 Topped Donuts',
    popular: true,
    vegetarian: true,
  },
  {
    id: 'donuts-kinder-bueno',
    name: '2 Kinder Bueno TOPPED Donuts',
    price: 5.50,
    description: '2 hot fresh donuts drizzled with creamy hazelnut milk chocolate Kinder Bueno style cream sauce and soft-serve.',
    image: '/donuts/donuts-kinder-bueno.webp',
    fallbackImage: '/donuts/donuts-kinder-bueno.jpg',
    category: 'donuts',
    subCategory: 'Topped Donuts',
    servingSize: '2 Topped Donuts',
    popular: true,
    vegetarian: true,
  },
  {
    id: 'donuts-cadbury-creme-egg',
    name: '2 Cadbury Creme Egg TOPPED Donuts',
    price: 5.50,
    description: '2 hot fresh donuts topped with rich milk chocolate and sweet yellow & white fondant creme egg swirl with soft-serve.',
    image: '/donuts/donuts-cadbury-creme-egg.webp',
    fallbackImage: '/donuts/donuts-cadbury-creme-egg.jpg',
    category: 'donuts',
    subCategory: 'Topped Donuts',
    servingSize: '2 Topped Donuts',
    popular: true,
    vegetarian: true,
  },
  {
    id: 'donuts-toffee',
    name: '2 Toffee TOPPED Donuts',
    price: 5.50,
    description: '2 hot fresh donuts drizzled with warm British seaside sticky butterscotch toffee syrup and creamy soft-serve ice cream.',
    image: '/donuts/donuts-toffee.webp',
    fallbackImage: '/donuts/donuts-toffee.jpg',
    category: 'donuts',
    subCategory: 'Topped Donuts',
    servingSize: '2 Topped Donuts',
    popular: true,
    vegetarian: true,
  },
];

export const FULL_MENU: MenuItem[] = OFFICIAL_MENU;

// Real reviews from our amazing customers on Google:
export const CUSTOMER_REVIEWS: CustomerReview[] = [
  {
    id: 'google-rev-1',
    name: 'Dave',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=160&h=160&q=80',
    rating: 5,
    comment: "We had a fantastic visit to Frankie's at the Beach in Ramsgate. The food was fresh, delicious, and generously portioned, and the drinks were great too.",
    date: 'a month ago',
    tag: 'Google Review',
  },
  {
    id: 'google-rev-2',
    name: 'Paula Dean',
    avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=160&h=160&q=80',
    rating: 5,
    comment: "I recently visited Frankie’s at the Beach in Ramsgate and had such a fantastic experience. From the moment we arrived, the atmosphere was welcoming, relaxed, and perfect for a day by the sea. The food was absolutely delicious—fresh...",
    date: 'a month ago',
    tag: 'Google Review',
  },
  {
    id: 'google-rev-3',
    name: 'Suzie Sutiyono',
    avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=160&h=160&q=80',
    rating: 5,
    comment: "Okay, this place right here, location location location. Yall really, you have to get right here this minute, nice food. Nice location, beautiful simple beach decor, reminds me of the old 60s feeling uknowwwhadimean? The burger with d...",
    date: '4 months ago',
    tag: 'Google Review',
  },
  {
    id: 'google-rev-4',
    name: 'Perfect Movie',
    avatar: 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?auto=format&fit=crop&w=160&h=160&q=80',
    rating: 5,
    comment: "I really love this place! Came last summer fairly regularly with a 2yr old who loved the rides and was excitedly looking forward to coming back again this year. Have been as often as I can so far and the rides are still perfect for his age...",
    date: '2 months ago',
    tag: 'Google Review',
  },
  {
    id: 'google-rev-5',
    name: 'peter rackley',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&w=160&h=160&q=80',
    rating: 5,
    comment: "Excellent food, great value for money and service is always friendly and professional. And right on the beach so the views are spectacular. What's not to love about frankies!",
    date: 'a month ago',
    tag: 'Google Review',
  },
  {
    id: 'google-rev-6',
    name: 'Xen Xenophontes',
    avatar: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?auto=format&fit=crop&w=160&h=160&q=80',
    rating: 5,
    comment: "Really great place to spend your day at the beach. Frankie and his team are great! Maggie and Kevin are super friendly. The team can't do enough for you. The food and drink is good value and really tasty! Fantastic burger selection.",
    date: 'a year ago',
    tag: 'Google Review',
  },
  {
    id: 'google-rev-7',
    name: 'Lauren French',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=160&h=160&q=80',
    rating: 5,
    comment: "Fantastic place,customer service is always friendly and with a smile - great rides for little ones the food is lovely and reasonably priced. My kids love it here our no.1 summer spot. 5*****",
    date: 'a month ago',
    tag: 'Google Review',
  },
  {
    id: 'google-rev-8',
    name: 'Cary',
    avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=160&h=160&q=80',
    rating: 5,
    comment: "Was welcomed and served by a really friendly, smiley and polite gentlemen today! Perfect location, no need to pack loads of food and drink and lug it to the beach. Because there's a bar that serves food right on the beach! Good music playing too! Makes going to the beach more enjoyable as a busy mum!",
    date: '4 months ago',
    tag: 'Google Review',
  },
  {
    id: 'google-rev-9',
    name: 'montana hassan',
    avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=160&h=160&q=80',
    rating: 5,
    comment: "Frankie’s at the beach is an incredible day out for the whole family! They have amazing restaurant quality burgers, a Bar for the adults & rides for the kids. Perfect location on the beach. Highly recommend a visit!",
    date: '4 months ago',
    tag: 'Google Review',
  },
  {
    id: 'google-rev-10',
    name: 'S Rahman',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=160&h=160&q=80',
    rating: 5,
    comment: "Always lovely to get some quality food after a nice day on the beach! Staff are lovely here and welcome all the customers. It’s right next to the kids playing area too which is handy while the kids are running around or jumping on the trampoline. Delicious food and great atmosphere!",
    date: '5 years ago',
    tag: 'Google Review',
  },
  {
    id: 'google-rev-11',
    name: 'Suzy Sue',
    avatar: 'https://images.unsplash.com/photo-1567532939604-b6b5b0db2604?auto=format&fit=crop&w=160&h=160&q=80',
    rating: 5,
    comment: "Very good love this place and great value for money .unlike Herbert's Gelato in Folkestone lol.! Frankie’s nailed it and such a lovely atmosphere there and my family love it there fun for the whole family .",
    date: '4 months ago',
    tag: 'Google Review',
  },
  {
    id: 'google-rev-12',
    name: 'ThermalSun',
    avatar: 'https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?auto=format&fit=crop&w=160&h=160&q=80',
    rating: 5,
    comment: "Early bike ride out to Ramsgate. Stopped here for a quick bite and seaside treats. Friendly and quick service. Sat in the sun and enjoyed the views for 30mins. Recommended.",
    date: '2 years ago',
    tag: 'Google Review',
  },
  {
    id: 'google-rev-13',
    name: 'Geoff Richardson',
    avatar: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&w=160&h=160&q=80',
    rating: 5,
    comment: "I came here after a friend recommended I go and try the food, I must say they were right, the food was amazing and the customer service was top notch too, it’s in a great location right on a sandy beach with good vibes and a great place to...",
    date: '4 months ago',
    tag: 'Google Review',
  },
  {
    id: 'google-rev-14',
    name: 'Karl Taylor',
    avatar: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=160&h=160&q=80',
    rating: 5,
    comment: "One best chips and hot dogs ever!!",
    date: '3 months ago',
    tag: 'Google Review',
  },
  {
    id: 'google-rev-15',
    name: 'Jonathan Marson',
    avatar: 'https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?auto=format&fit=crop&w=160&h=160&q=80',
    rating: 5,
    comment: "By far one of my coastal street food experiences, great food and fantastic customer service.",
    date: 'a month ago',
    tag: 'Google Review',
  },
  {
    id: 'google-rev-16',
    name: 'Adam Eales',
    avatar: 'https://images.unsplash.com/photo-1528892952291-009c663ce843?auto=format&fit=crop&w=160&h=160&q=80',
    rating: 5,
    comment: "Great food and even better location right on the beach and a happy smile to greet you",
    date: 'a month ago',
    tag: 'Google Review',
  },
  {
    id: 'google-rev-17',
    name: 'Chris C',
    avatar: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&w=160&h=160&q=80',
    rating: 5,
    comment: "Amazing burgers and selection of food. Friendly staff and great location right by the beach",
    date: 'a year ago',
    tag: 'Google Review',
  },
];

export const RESTAURANT_INFO = {
  name: "Frankie's @ the beach",
  visitUs: {
    line1: "Kiosk 1",
    line2: "Marina Esplanade",
    line3: "Ramsgate",
    postcode: "CT11 8LS",
    country: "United Kingdom",
    fullAddress: "Kiosk 1, Marina Esplanade, Ramsgate CT11 8LS, United Kingdom",
    shortAddress: "Kiosk 1, Marina Esplanade, Ramsgate",
  },
  contact: {
    phone: "+44 7554 663569",
    phoneHref: "tel:+447554663569",
    whatsappNumber: "447554663569",
    email: "frankiefernando@msn.com",
    emailHref: "mailto:frankiefernando@msn.com",
  },
  hours: {
    monThu: "Mon - Thu: 9 AM - 5 PM",
    friSun: "Fri - Sun: 10 AM - 6 PM",
    openStatus: "Open Today by the Sea",
  },
};
